import React, {useState, useEffect} from 'react'
// Styles
import './rdscd.style.css'
// Image
import RewardImg from '../../assets/images/rewards/reward-detail.png'
// Actions
import { Base_API } from '../../_actions/matcher'
// Toast
import {toast as notify, Toaster} from 'react-hot-toast'

function RedeemReward_Success_Detail() {

    const [loading, setLoading] = useState(true);
    const [pageData, setPageData] = useState(null);

    useEffect(() => {
        dataInit();
    },[])

    const dataInit = async() => {
        await redeemDetailInit();
        handlerLoader('inactive');
    }

    const handlerLoader = status => {
        if(status === 'inactive')
        {
            setLoading(false);
        }else
        {
            setLoading(true);
        }
    }

    const redeemDetailInit = () => {
        return new Promise(async resolve => {
            let detail = !!localStorage.getItem('redeem-detail') ? DecryptedOBJ(localStorage.getItem('redeem-detail')) : null;
            // console.log('Detail: ', detail);
            if(!!detail)
            {
                setPageData(detail);
                resolve();
            }
            
            // console.log('detail: ', detail); 
        })
    }

    const renderDescription = (
        <div dangerouslySetInnerHTML={{__html: !!pageData && pageData.description}}></div>
    )

    // Handle Submit
    const handleSubmit = () => {
        window.location.href = `${Base_API.pathWeb}/n-health/my-reward`;
    }

    const handlerClipboard = () => {
        if(!!pageData)
        {
            navigator.clipboard.writeText(pageData.redeemcode)
            .then(() => {
                notify.success('คัดลอกลิงก์สำเร็จ', {duration: 2000});
            })         
        }
    }

    if(loading)
    {
        return (
            <div className="sls-loader-container">
                <div className="sls-loader"></div>
            </div>
        )
    }else
    {
        return (
            <div className="rdwscd-container">
                {/* reward img */}
                <div 
                    className="rw-img"
                    style={{backgroundImage: `url(${!!pageData && String(pageData.Cover)})`}}
                ></div>
                {/* header text */}
                <h1 className="rw-name">{!!pageData && pageData.Title}</h1>

                {/* Description */}
                {renderDescription}

                {/* Copy Reward Code */}
                <div className="rw-code-wrap">
                    <p className="rw-code-label">{!!pageData && pageData.redeemcode}</p> 
                    <button 
                        className="rw-code-btn"
                        onClick={handlerClipboard}
                    >
                        คัดลอกรีวอร์ดโค้ด
                    </button>
                </div> 

                {/* expiresin date */}
                {/* <p className="exp-date t-normal">หมดเขต <span className="t-bold">15 พ.ย. 2565</span></p> */}
                {/* rw policy */}
                <div className="rw-plc-wrap t-normal t-lowblue">
                    <p className="label">ข้อกำหนดและเงื่อนไข</p>
                    <ul>
                        <li><span>1. </span>เพื่อให้ท่านได้รับบริการที่สะดวกรวดเร็ว กรุณานัดหมายล่วงหน้า 1 วัน</li>
                        <li><span>2. </span>กรณีที่ท่านไม่ได้ทำการนัดหมายล่วงหน้าเจ้าหน้าที่ขอตรวจสอบข้อมูล การชำระเงินโดยท่านต้องแสดงหลักฐานใบเสร็จรับเงินกับเจ้าหน้าที่ </li>
                        <li><span>3. </span>หากท่านไม่ได้เป็นผู้เข้ารับการตรวจสุขภาพเองขอให้ผู้ที่เข้ารับบริการแทนแสดง หลักฐานใบเสร็จของท่านเพื่อรับบริการ </li>
                        <li><span>4. </span>แพ็กเกจที่ท่านได้สั่งซื้อและชำระเงินแล้ว ไม่สามารถแลก เปลี่ยน หรือคืนเป็นเงินสดได้</li>
                    </ul>
                </div>
                {/* Button (go to my reward page) */}
                <div className="btn-wrap">
                    <button 
                        className="btn-submit"
                        onClick={handleSubmit}
                    >
                        ไปหน้ารีวอร์ดของฉัน
                    </button>
                </div>

                <Toaster/>
            </div>
        )
    }
}

export default RedeemReward_Success_Detail